// extracted by mini-css-extract-plugin
export default {"orderAttentionAlertRow":"styles_orderAttentionAlertRow__CZ4y1","expressDeliveryAlertPulse":"styles_expressDeliveryAlertPulse__PtSPN"};